import { createAction, props } from "@ngrx/store";
import { LatestToSModel } from "./selected-variables.reducer";

export const RESET_VARIABLES = 'Reset Variables';
export const SET_ANIMAL_ID = 'Set Animal Id';
export const LOAD_LATEST_TOS = 'Set Latest ToS';
export const SET_LATEST_TOS = 'Set Latest ToS';

export const resetVariables = createAction(RESET_VARIABLES);
export const setAnimalId = createAction(SET_ANIMAL_ID, props<{ animalId: string }>());
export const loadLatestToS = createAction(LOAD_LATEST_TOS);
export const setLatestToS = createAction(SET_LATEST_TOS, props<{ latestToS: LatestToSModel }>());
